import store from '@/store'
import { app } from '@/main.js'
import { useToast } from 'vue-toastification'
import router from '@/router'

const toast = useToast()


export default () => {

    if (app.helpers.getTokenParam()){
        store.commit('auth/setToken', app.helpers.getTokenParam());
    }


    if (!store.state.auth.isSuperAdmin) {
        toast.error("Only super admins are allowed to view this page.");
        router.push('/dashboard');

    }

}